<main class="main">
  <router-outlet></router-outlet>
  <!-- Modal Email Quote-->
  <app-email-quote></app-email-quote>
  <!-- Modal Alert Disclaimer -->
  <div class="modal" [ngClass]="{ show: showPaymentGatewayAlert }">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <!--<button
            type="button"
            class="btn-close"
            aria-label="Close"
            style="float: right; box-shadow: none"
            (click)="closePaymentGatewayAlert()"
          ></button>-->
          <p style="padding-right: 20px">
            The site is currently experiencing intermittent issues, resulting in system unavailability. 
            We apologise for any inconvenience this may cause and appreciate your patience as we work to resolve the issue.
          </p>
        </div>
      </div>
    </div>
  </div>
</main>
<app-loading-mask *ngIf="showLoadingMask$ | async"></app-loading-mask>
<app-loading-mask *ngIf="serverSideHomePageMask"></app-loading-mask>
<p-toast />
